import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  formData: {
    requestCode?: string;
    positionCode?: string;
    departmentCode?: string;
    approveStatus?: string;
    currentDepartment?: string;
    departmentLevel2Code?: string;
    from?: string;
    to?: string;
  };
}

const initialState: InitialState = {
  formData: {
    requestCode: "",
    positionCode: "",
    departmentCode: "",
    approveStatus: "",
    from: "",
    to: "",
    departmentLevel2Code: "",
  },
};

const fromSearchRecruitmentSlice = createSlice({
  name: "fromSearchInternalDocument",
  initialState,
  reducers: {
    updateFormSearchRecruitment: (state, action) => {
      state.formData = {
        ...state.formData,
        ...action.payload,
      };
    },

    resetFormSearchRecruitment: () => {
      return { ...initialState };
    },
  },
});

export const { updateFormSearchRecruitment, resetFormSearchRecruitment } =
  fromSearchRecruitmentSlice.actions;

export default fromSearchRecruitmentSlice.reducer;
